import { z } from 'zod/v4';
import { PerformedBySchema } from '../../performed-by/index.js';
import { ToolCategory, ToolName, ToolPolicy, ToolWeight } from '../types.js';
import { searchEnvelopeSchema, searchInputSchema } from './envelope.js';
const filtersSchema = z.object({
    updateTypeIds: z.array(z.uuid()).optional(),
    pausing: z
        .boolean()
        .optional()
        .describe('true = only updates from pausing update types; false = only non-pausing; omit for both.'),
    rolledBack: z
        .boolean()
        .optional()
        .describe('true = only rolled-back updates; false = only active (non-rolled-back); omit for both.'),
    since: z.iso.datetime().optional(),
});
const itemSchema = z.object({
    updateId: z.uuid(),
    updateTypeId: z.uuid(),
    label: z.string(),
    pausing: z.boolean(),
    important: z.boolean(),
    appliedAt: z.iso.datetime(),
    pausedAt: z.iso.datetime().nullable(),
    continuedAt: z.iso.datetime().nullable(),
    isActive: z.boolean(),
    rolledBack: z.boolean(),
    update: z.string().max(2000).nullable(),
    createdBy: PerformedBySchema.nullable(),
});
const facetsSchema = z.object({
    pausing: z.number().int(),
    important: z.number().int(),
    rolledBack: z.number().int(),
});
const inputSchema = searchInputSchema(filtersSchema);
const outputSchema = searchEnvelopeSchema(itemSchema, facetsSchema);
export const searchUpdatesTool = {
    name: ToolName.SearchUpdates,
    category: ToolCategory.CaseManagement,
    weight: ToolWeight.Light,
    version: 3,
    defaultPolicy: ToolPolicy.AutoRun,
    llmDescription: 'List updates already applied to this case. pausedAt is when an update started; continuedAt is when it stopped being active; isActive identifies a current pausing update. Inspect this before proposing CREATE_UPDATE so you do not duplicate the current state. For the mixed activity feed use search_case_history; to browse selectable update types use search_update_types.',
    inputSchema,
    outputSchema,
};
//# sourceMappingURL=search-updates.js.map